export default (value, url) => (value > 0
  ? `
      <td class="prominentLink" title="Click to view patients" data-toggle="tooltip" data-container="body" data-placement="left" data-href="${url}">
        <a class="prominentLink" href="javascript:void()">${value}</a>
      </td>`
  : '<td>0</td>');
